import Image from "next/image";
import React from "react";
import preloaderImgTwo from "../../../public/assets/img/logo/logo-text-2.png";

const Preloader = () => (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{ minHeight: "50vh" }}
  >
    <span className="loader" role="status" aria-label="Loading" />
    <Image
      className="loading-logo-text-2"
      style={{ width: "auto", height: "auto" }}
      src={preloaderImgTwo}
      alt="image not found"
      loading="eager"
    />
  </div>
);

export default Preloader;
